import React, { useEffect, useState } from 'react';
import { Range } from 'react-range';

const PriceRangeSlider = ({ minPrice = 0, maxPrice = 35990, step = 100, onPriceChange ,closeSidebar,filters}) => {
  const [priceRange, setPriceRange] = useState([minPrice, maxPrice]);

  const handleRangeChange = (values) => {
    setPriceRange(values);
  };
  const handleFilterClick = () => {
    if (onPriceChange) {
      onPriceChange(priceRange);
      closeSidebar()
    }
  };
  useEffect(()=>{
    if(filters.start_price && filters.end_price){
      setPriceRange([filters.start_price,filters.end_price])
    }
  },[filters])
  return (
    <div className="price-slider-container w-full mb-4">
      <h3 className="text-sm font-medium mb-5 relative underlineFilter">Price</h3>
      <Range
        values={priceRange}
        step={step}
        min={minPrice}
        max={maxPrice}
        onChange={handleRangeChange}
        renderTrack={({ props, children }) => (
          <div
            {...props}
            className="relative w-full h-0.5 bg-gray-300"
          >
            <div
              className="absolute bg-black h-0.5"
              style={{
                left: `${((priceRange[0] - minPrice) / (maxPrice - minPrice)) * 100}%`,
                width: `${((priceRange[1] - priceRange[0]) / (maxPrice - minPrice)) * 100}%`,
              }}
            />
            {children}
          </div>
        )}
        renderThumb={({ props, index }) => (
          <div
            {...props}
            className="h-3 w-[2px] bg-black"
            style={{
              ...props.style,
              top: '0px',  // Aligns the handle with the track
              borderRadius: '0px',  // Square shape
              border: '2px solid #000',  // Distinct border
              boxShadow: '0 0 3px rgba(0, 0, 0, 0.3)',
            }}
          />
        )}
      />

      <p className="text-sm mt-4">
        Price: Rs.{priceRange[0]?.toLocaleString()} — Rs.{priceRange[1]?.toLocaleString()}
      </p>
      <button
        className="mt-4 px-4 py-1 border-2 border-black bg-white text-black font-medium rounded"
        onClick={handleFilterClick} // Trigger the API call on button click
      >
        Filter
      </button>
    </div>
  );
};

export default PriceRangeSlider;
